import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { deleteIssuesByIdVisibilitySlice } from './delete';
import { postIssuesByIdVisibilitySlice } from './post';

export const issuesByIdVisibilityReducers = combineReducers({
	delete: deleteIssuesByIdVisibilitySlice.asyncReducers,
	post: postIssuesByIdVisibilitySlice.asyncReducers
});

export const issuesByIdVisibilityWatchers = combineAllWatchers([
	deleteIssuesByIdVisibilitySlice.asyncWatchers,
	postIssuesByIdVisibilitySlice.asyncWatchers
]);
